export default __webpack_public_path__ + "static/media/cardiogram.1344852c.png";